<template>
  <div class="page">1</div>
</template>

<script>
// import tools from "@/utils/tools";

export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    // console.log("tools -- ", tools);
  },
};
</script>

<style lang="less" scoped>
@import "../styles/default.less";

.page {
  min-height: 100vh;
  padding: 16px;
  background: #f5f5f5;
}
</style>
